import { render, staticRenderFns } from "./AskMessages.vue?vue&type=template&id=da8a0400&scoped=true&"
import script from "./AskMessages.vue?vue&type=script&setup=true&lang=js&"
export * from "./AskMessages.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AskMessages.vue?vue&type=style&index=0&id=da8a0400&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8a0400",
  null
  
)

export default component.exports